var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#020203;}\n"),React.createElement("polygon",{"id":"arr","className":"st02","points":"28.4,15.7 21.6,9 21.6,14.6 2.2,14.6 2.2,0 0,0 0,16.9 21.6,16.9 21.6,22.5 ","key":1})]);
}

ArrowInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 28.4 22.5","style":{"enableBackground":"new 0 0 28.4 22.5"},"xmlSpace":"preserve"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
